import React from "react";
import moment from "moment-timezone";
import { Form } from "react-bootstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";

function AnalyticDateRangePicker(props) {
  const formatDate = (date) => {
    return moment(date).format("MMMM DD, YYYY");
  };
  return (
    <div className="well">
      <h5>DATE RANGE</h5>
      <DateRangePicker
        onApply={props.handleEvent}
        ranges={{
          Today: [moment(), moment()],
          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }}
        alwaysShowCalendars
        autoApply
      >
        <Form>
          <Form.Group controlId="daterangepicker">
            <Form.Control
              type="text"
              placeholder="Select a date range"
              readOnly
              value={
                props.duration != null
                  ? formatDate(props.duration.fromDate) +
                    " - " +
                    formatDate(props.duration.toDate)
                  : "Select a date range"
              }
            />
          </Form.Group>
        </Form>
      </DateRangePicker>
    </div>
  );
}

export default AnalyticDateRangePicker;
